import React from "react"
import {TextMedium} from "../text/text"

export interface ListedValueProps {
  label: string
}

export const ListedValue: React.FC<ListedValueProps> = ({label, children}) => {
  return <div>
    <label data-hj-suppress={true}>
      <TextMedium color="dark-grey">{label}</TextMedium>
      {children}
    </label>
  </div>
}
